<div [innerHTML]="content" class="pipeline-content"></div>
